<script>
import treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";

export default {
  mixins: [apibtoast, apigeneric],
  components: {
    treeselect,
  },
  props: ["Userid", "Uygulamaid", "title"],
  data: () => ({
    UserData: {},
    AddEdit: "Add",
    FormData: {
      Userid: null,
      Uygulamaid: null,
      Birimids: [],
    },
    value: [],
    children: [],
    options: [],
    birimlist: [],
    veri: [],
    clearable: true,
    searchable: true,
    disabled: false,
    openOnClick: true,
    openOnFocus: false,
    clearOnSelect: true,
    alwaysOpen: false,
    appendToBody: false,
    sortValueBy: "ORDER_SELECTED", //LEVEL , INDEX
    valueConsistsOf: "ALL", // "BRANCH_PRIORITY", "LEAF_PRIORITY","ALL_WITH_INDETERMINATE"
    rtl: false,
    flat: false,
    limit: 0,
    Page: {
      PageNumber: "1",
      PageSize: "9999",
      PageDataSize: "1",
    },
  }),
  methods: {
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ActionsFilterGet({
        Service: "ouserbirimyetki",
        Page: Page,
        Filter: "&Userid=" + this.Userid + "&Uygulamaid=" + this.Uygulamaid,
      }).then((res) => {
        this.UserData = res.Data;
        if (res.Data.length > 0) {
          this.FormData.Birimids = [];
          this.FormData.Id = res.Data[0].Id;
          for (var i = 0; i < res.Data.length; i++) {
            this.FormData.Birimids.push(res.Data[i].Birimid);
          }
          this.AddEdit = "Edit";
        }
      });
    },
    BirimYukle() {
      for (var i = 0; i < this.birimlist.length; i++) {
        this.veri.push({
          id: this.birimlist[i].Id,
          BirimAdi: this.birimlist[i].BirimAdi,
          UstBirimId: this.birimlist[i].UstBirimId,
        });
      }

      this.options = [];
      this.children = [];

      for (var s = 0; s < this.veri.length; s++) {
        if (this.veri[s].UstBirimId == null) {
          this.options.push({
            id: this.veri[s].id,
            label: this.veri[s].BirimAdi,
            children: null,
          });
        }
      }

      for (var a = 0; a < this.options.length; a++) {
        let cocuk1 = [];
        for (var b = 0; b < this.veri.length; b++) {
          if (
            this.options[a].id == this.veri[b].UstBirimId &&
            this.veri[b].UstBirimId != null
          ) {
            cocuk1.push({
              id: this.veri[b].id,
              label: this.veri[b].BirimAdi,
              children: null,
            });
          }
        }

        if (cocuk1.length > 0) {
          this.options[a].children = cocuk1;

          for (var c = 0; c < this.options[a].children.length; c++) {
            let cocuk2 = [];

            for (var d = 0; d < this.veri.length; d++) {
              if (
                this.options[a].children[c].id == this.veri[d].UstBirimId &&
                this.veri[d].UstBirimId != null
              ) {
                cocuk2.push({
                  id: this.veri[d].id,
                  label: this.veri[d].BirimAdi,
                  children: null,
                });
              }
            }
            if (cocuk2.length > 0) {
              this.options[a].children[c].children = cocuk2;

              for (
                var e = 0;
                e < this.options[a].children[c].children.length;
                e++
              ) {
                let cocuk3 = [];

                for (var f = 0; f < this.veri.length; f++) {
                  if (
                    this.options[a].children[c].children[e].id ==
                      this.veri[f].UstBirimId &&
                    this.veri[f].UstBirimId != null
                  ) {
                    cocuk3.push({
                      id: this.veri[f].id,
                      label: this.veri[f].BirimAdi,
                      children: null,
                    });
                  }
                }
                if (cocuk3.length > 0) {
                  this.options[a].children[c].children[e].children = cocuk3;

                  for (
                    var g = 0;
                    g < this.options[a].children[c].children[e].children.length;
                    g++
                  ) {
                    let cocuk4 = [];

                    for (var h = 0; h < this.veri.length; h++) {
                      if (
                        this.options[a].children[c].children[e].children[g]
                          .id == this.veri[h].UstBirimId &&
                        this.veri[h].UstBirimId != null
                      ) {
                        cocuk4.push({
                          id: this.veri[h].id,
                          label: this.veri[h].BirimAdi,
                          children: null,
                        });
                      }
                    }
                    if (cocuk4.length > 0) {
                      this.options[a].children[c].children[e].children[
                        g
                      ].children = cocuk4;

                      for (
                        var j = 0;
                        j <
                        this.options[a].children[c].children[e].children[g]
                          .children.length;
                        j++
                      ) {
                        let cocuk5 = [];

                        for (var k = 0; k < this.veri.length; k++) {
                          if (
                            this.options[a].children[c].children[e].children[g]
                              .children[j].id == this.veri[k].UstBirimId &&
                            this.veri[k].UstBirimId != null
                          ) {
                            cocuk5.push({
                              id: this.veri[k].id,
                              label: this.veri[k].BirimAdi,
                              children: null,
                            });
                          }
                        }
                        if (cocuk5.length > 0) {
                          this.options[a].children[c].children[e].children[
                            g
                          ].children[j].children = cocuk5;
                        } else {
                          this.options[a].children[c].children[e].children[
                            g
                          ].children[j].children = null;
                        }
                      }
                    } else {
                      this.options[a].children[c].children[e].children[
                        g
                      ].children = null;
                    }
                  }
                } else {
                  this.options[a].children[c].children[e].children = null;
                }
              }
            } else {
              this.options[a].children[c].children = null;
            }
          }
        } else {
          this.options[a].children = null;
        }
      }

      let tumu = [];
      tumu.push({ id: 1, label: "Tümü", children: null });
      tumu[0].children = this.options;
      this.options = tumu;
    },
    YetkiSubmit() {
      if (this.AddEdit == "Add") {
        this.$delete(this.FormData, "Id");
        this.Post("ouserbirimyetki", this.FormData).then((res) => {
          if (res) {
            this.AddEdit == "Edit";
          }
        });
      } else {
        this.Update("ouserbirimyetki", this.FormData);
      }
    },
  },
  created() {
    this.Get();
    this.FormData.Userid = this.Userid;
    this.FormData.Uygulamaid = this.Uygulamaid;

    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    this.ActionsFilterGet({ Service: "OBirim/GetTreeByAnaBirim", Page: Page, Filter: "&GetProgramlarVeBolumler=true"}).then(
      (res) => {
 
        let tumu = [];
        tumu.push({ id: 1, label: "Tümü", children: null });
        let gelen_veri = JSON.stringify(res.Data); 
        let silinecek = '"children":null,';
        gelen_veri = gelen_veri.replaceAll(silinecek, ""); 
        tumu[0].children = JSON.parse(gelen_veri);
        this.options = tumu; 
        this.value = this.selected;
      }
    );
  },
};
</script>
<template>
  <div>
    <b-form-group id="gbirimler" :label="title" label-for="text">
      <div class="row">
        <div class="col-10">
          <treeselect
            :multiple="true"
            :options="options"
            :flat="false"
            :sort-value-by="sortValueBy"
            :default-expand-level="1"
            placeholder="Birim Seçiniz"
            :clearable="clearable"
            :searchable="searchable"
            :disabled="disabled"
            :open-on-click="openOnClick"
            :open-on-focus="openOnFocus"
            :clear-on-select="clearOnSelect"
            :always-open="alwaysOpen"
            :append-to-body="appendToBody"
            :max-height="200"
            v-model="FormData.Birimids"
            :input="$emit('Secilmis_Idler', value)"
            :rtl="rtl"
            :value-consists-of="valueConsistsOf"
            @select="Secilen($event)"
          />
          <treeselect-value :value="value" />
        </div>
        <div class="col-2">
          <button class="btn-success" @click="YetkiSubmit()">
            <i class="mdi mdi-account-check-outline"></i>
          </button>
        </div>
      </div>
    </b-form-group>
  </div>
</template>
